import React, { useContext, useEffect, useState, memo } from "react";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import ConnectionTypeGroup from "./ConnectionTypeGroup";
const MAX_RETRIES = 3;
 
const WebMapConnectionType = ({ type, data = [], fetchHandler }) => {
  const { supplyFilters, demandFilters, onChangeSupplyConnectionType, onChangeDemandConnectionType, appliedFilters } = useContext(WebMapContext);
  const [value, setValue] = useState();
  const [retryCount, setRetryCount] = useState(0);
 
  useEffect(() => {
    setValue(null);
    if (data.length > 0) {
      let val = data[0].value;
      if (type === 'supply_best' && supplyFilters.connectionType.best)
        val = supplyFilters.connectionType.best;
      else if (type === 'supply_custom' && supplyFilters.connectionType.custom)
        val = supplyFilters.connectionType.custom;
      else if (type === 'demand' && demandFilters.connectionType)
        val = demandFilters.connectionType;
      setValue(val);
    } 
    else if(retryCount < MAX_RETRIES) {
      fetchHandler(type === 'supply_best'
        ? 'best_operator_statistics'
        : type === 'supply_custom'
          ? 'operator_statistics'
          : 'demand_operator_statistics', type);
          setRetryCount((prev) => prev + 1);
    }
  }, [type, data]);

  //Fetch & reset connection types on year and quarter change
  useEffect(() => {
    fetchHandler(
      type === "supply_best"
        ? "best_operator_statistics"
        : type === "supply_custom"
        ? "operator_statistics"
        : "demand_operator_statistics",
      type
    );
    setRetryCount(0);
  }, [appliedFilters.year, appliedFilters.quarter]);
 
  useEffect(() => {
    if (value) {
      if (type === 'supply_best')
        onChangeSupplyConnectionType({ ...supplyFilters.connectionType, best: value });
      else if (type === 'supply_custom')
        onChangeSupplyConnectionType({ ...supplyFilters.connectionType, custom: value });
      else
        onChangeDemandConnectionType(value);
    }
  }, [value]);
 
  return (
    <>
      <div style={{ width: "100%" }}>
        {value && data.length > 0
          ? <ConnectionTypeGroup
            data={data}
            value={value}
            handleChange={(val) => setValue(val)}
          />
          : <></>}
      </div>
    </>
  )
};
 
export default memo(WebMapConnectionType);